import { queryOptions } from '@tanstack/react-query';
import { listApiKeysServerFn } from '@/server/functions/api-keys';

export const apiKeyListQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ['api-keys', orgSlug],
    queryFn: () => listApiKeysServerFn({ data: { orgSlug } }),
  });
